import { fileTokenUrl, resolveFileUrl } from "../lib/api";
import { Icon } from "./icons";

export function docKind(d) {
  if (!d) return "outro";
  const k = (d.kind || d.category || d.type || "").toLowerCase();
  if (k.includes("partitura") || k.includes("score")) return "partitura";
  if (k.includes("letra") || k.includes("lyric")) return "letra";
  const n = (d.name || d.title || d.url || "").toLowerCase();
  if (n.includes("partitura") || n.includes("score")) return "partitura";
  if (n.includes("letra") || n.includes("lyric")) return "letra";
  return "outro";
}

async function openDoc(d) {
  const path = d.url || d.path;
  if (!path) return;
  try {
    const url = path.startsWith("http") ? path : await fileTokenUrl(path);
    window.open(url, "_blank", "noopener");
  } catch {
    const url = resolveFileUrl(path);
    if (url) window.open(url, "_blank", "noopener");
  }
}

export function DocumentList({ documents = [] }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {documents.map((d, i) => (
        <button
          key={d.id || i}
          onClick={() => openDoc(d)}
          className="card"
          style={{ display: "flex", alignItems: "center", gap: 12, padding: 12, cursor: "pointer", textAlign: "left", color: "inherit" }}
          data-testid={`document-${i}`}
        >
          <div style={{ width: 38, height: 38, borderRadius: 10, background: "var(--surface-3)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Icon name="document-text" size={18} color="var(--brand-primary)" />
          </div>
          <span style={{ flex: 1, minWidth: 0, fontFamily: "var(--f-medium)", fontSize: 14, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {d.name || d.title || "Documento"}
          </span>
          <Icon name="download" size={18} color="var(--muted)" />
        </button>
      ))}
    </div>
  );
}
